import React from "react";
import MAvatar from "@/components/ui/atoms/MAvatar";
import MBadge from "@/components/ui/atoms/MBadge";
import MCheckbox from "@/components/ui/atoms/MCheckbox";
import { MButton } from "@/components/ui/atoms/MButtons";
import { IconInfoCircle } from "@tabler/icons-react";
import styles from "./ManageMyAccess.module.css";

export type AccessMemberRowRight =
  | {
      type: "checkbox";
      checked: boolean;
      disabled?: boolean;
      onChange: () => void;
    }
  | { type: "button"; label: string; disabled?: boolean; onClick: () => void }
  | { type: "none" };

export interface AccessMemberRowProps {
  name: string;
  isOwner?: boolean;
  consentPending?: boolean;
  onConsentInfoClick?: () => void;
  right: AccessMemberRowRight;
}

const AccessMemberRow: React.FC<AccessMemberRowProps> = ({
  name,
  isOwner,
  consentPending,
  onConsentInfoClick,
  right,
}) => {
  return (
    <div className={styles.memberCard}>
      <div className={styles.mainWrap}>
        <div className={styles.wrapper}>
          <MAvatar size="xs" px={24} type="no-dp" text={name} />
          <div className={styles.textGroup}>
            <div className={styles.memberName}>{name}</div>
            {(isOwner || consentPending) && (
              <div className={styles.badgeRow}>
                {isOwner && (
                  <MBadge className={styles.ownerBadge}>Owner</MBadge>
                )}
                {consentPending && (
                  <>
                    <MBadge variant="orange-alert">Consent pending</MBadge>
                    <IconInfoCircle
                      size={20}
                      color="#407ED0"
                      className={styles.consentInfoIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        onConsentInfoClick?.();
                      }}
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.rightIconDiv}>
          {right.type === "checkbox" && (
            <MCheckbox
              size="compact"
              checked={right.checked}
              disabled={right.disabled}
              onChange={right.disabled ? undefined : right.onChange}
              readOnly={right.disabled}
            />
          )}
          {right.type === "button" && (
            <MButton
              variant="outline"
              size="sm"
              disabled={right.disabled}
              onClick={right.onClick}
              className={styles.askButton}
            >
              {right.label}
            </MButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessMemberRow;
